import { css } from '@emotion/css'
import {
  spacing,
  fontFamily,
  fontWeight,
  fontSize,
  breakpoint,
  shorthandHelper,
  colors,
  hexToRgba,
  mediaQueryHelper,
} from '@offerzen/pinata-shame'

const styles = {
  navigation: css({
    height: '100%',
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    alignItems: 'stretch',
  }),

  link: css({
    boxSizing: 'border-box',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    color: hexToRgba(colors.white, 0.6),
    textDecoration: 'none',
    borderTop: '2px solid transparent',
    borderBottom: '2px solid transparent',
    transition: 'color 0.2s',
    margin: shorthandHelper([0, spacing.small]),

    '&:hover': {
      color: colors.white,
    },

    '&:focus': {
      outline: 'none',
      color: colors.white,
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      margin: shorthandHelper([0, spacing.default]),
    },

    [mediaQueryHelper(1025)]: {
      margin: shorthandHelper([0, spacing.medium]),
    },
  }),

  activeLink: css({
    fontWeight: fontWeight.semiBold,
    color: colors.white,
    borderBottomColor: colors.cornflowerBlue,
  }),

  unread: css({
    borderRadius: '50%',
    backgroundColor: colors.cornflowerBlue,
    color: colors.white,
    fontSize: fontSize.small,
    width: 20,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: spacing.small,
  }),

  dropdown: css({
    marginLeft: spacing.small,
    height: '100%',
    display: 'flex',
    alignItems: 'center',

    [mediaQueryHelper(breakpoint.tablet)]: {
      marginLeft: spacing.default,
    },

    [mediaQueryHelper(1025)]: {
      marginLeft: spacing.medium,
    },

    '& > a': {
      borderTop: '2px solid transparent',
      borderBottom: '2px solid transparent',
      opacity: 0.6,
      transition: 'color 0.2s',
      alignSelf: 'center',
      height: '100%',

      '&:hover': {
        opacity: 1,
      },
    },
  }),
}

export default styles
